/* istanbul ignore file */
import React from "react";
import { bedragFormatNull, monthDivision } from "../infra/scenario-utils";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { CitationRef } from "../citation-notes";
import { ToelichtingOptions } from "../../../../.generated/rapportage/rapportagetypes";

export interface BenodigdInkomenTableProps {
  data: BenodigdInkomenTableData[];
}

export interface BenodigdInkomenTableData {
  benodigdInkomenBedrag: number | null;
  tekortBenodigInkomenBedrag: number | null;
  tekortNettoInkomenBedrag: number | null;
}

const emptyData = {
  minimaalBenodigd: "",
  maandelijksTekort: "",
  nettoMaandelijksTekort: "",
};

export const BenodigdInkomenTable: React.FC<BenodigdInkomenTableProps> = ({
  data,
}: BenodigdInkomenTableProps) => {
  const dataTransformed = data.map((item) => {
    if (item.benodigdInkomenBedrag === null) {
      return emptyData;
    }
    return {
      minimaalBenodigd: bedragFormatNull(
        item.benodigdInkomenBedrag,
        monthDivision,
      ),
      maandelijksTekort: bedragFormatNull(
        item.tekortBenodigInkomenBedrag,
        monthDivision,
      ),
      nettoMaandelijksTekort: bedragFormatNull(
        item.tekortNettoInkomenBedrag,
        monthDivision,
      ),
    };
  });

  const columns: Column[] = [
    {
      header: "",
      accessor: () => "",
    },
    {
      header: (
        <>
          Minimaal benodigd inkomen voor uw hypotheek{" "}
          <CitationRef type={ToelichtingOptions.BrutoNettoTekort} />
        </>
      ),
      accessor: "minimaalBenodigd",
    },
    {
      header: "Maandelijks tekort aan inkomsten voor uw hypotheek",
      accessor: "maandelijksTekort",
      style: "font-weight: bold;",
      violation: (value: string) => {
        const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
        return numericValue > 0;
      },
    },
    {
      header: <>Netto maandelijks tekort aan inkomsten voor uw hypotheek</>,
      accessor: (data: BenodigdInkomenTableData) => {
        return data.tekortNettoInkomenBedrag
          ? bedragFormatNull(data.tekortNettoInkomenBedrag)
          : null;
      },
      violation: (value: string) => {
        const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
        return numericValue > 0;
      },
    },
  ];

  return (
    <Table
      columns={columns}
      data={dataTransformed}
      rotate
      showHeader={false}
      id="benodigd-inkomen-table"
      className="scenario__table mb-4 table table-striped table-bordered table-hover table-responsive"
      regularStyles={dataTransformed.length > 1}
    />
  );
};
